import { css } from '@emotion/core';

import { Theme, titleText, subtitleText } from 'features/Theme';

export default {
  headingContainer: (theme: Theme) => css`
    text-align: center;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  titleText: (theme: Theme) => css`
    ${titleText(theme)}
    margin-bottom: ${theme.mui.spacing(2)}px;
  `,
  idPrompt: (theme: Theme) => css`
    p {
      ${subtitleText(theme)}
      margin-bottom: ${theme.mui.spacing(2)}px;
    }
  `,
  formFields: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  submitButton: (theme: Theme) => css`
    &.MuiButton-root {
      margin-bottom: ${theme.mui.spacing(2)}px;
    }
  `,
};
